import { Colors, Media } from 'enums';
import styled from 'styled-components';
import { Button, Icon } from 'view/atoms';

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  .css-1qp7fi1-container {
    margin-top: 0px !important;
  }
`;

export const ProfileButton = styled.div`
  width: 100%;
  border-radius: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border: 1px solid transparent;

  background-color: #ffffff;
  padding: 11px 16px;
  gap: 10px;

  &:hover {
    border: 1px solid ${Colors.gray3};
  }

  @media ${Media.notebook} {
    background-color: #f5f5f4;
    padding: 11px 24px;
    gap: 16px;
  }
`;

export const FavIcon = styled(Icon)`
  width: 24px;
  height: 20px;
  padding: 4px;

  @media ${Media.notebook} {
    width: 24px !important;
    height: 20px !important;
  }

  @media ${Media.mobile} {
    width: 18px;
    height: 18px;
    padding: 3px;
  }
`;

export const InviteButton = styled(ProfileButton)`
  & > :last-child {
    margin-left: auto;
  }
`;

export const ExitButton = styled(Button)`
  & > p {
    margin: 0 0 0 10px;
  }

  @media ${Media.notebook} {
    & > p {
      margin: 0 0 0 16px;
    }
  }
`;
